import React from "react";
import { Section, Kicker, Heading } from "../components/ui";
import Reveal from "../components/Reveal";

const BRANDS = [
  {
    name: "Northwood",
    logo: "/brands/northwood.png?v=3",
    dark: false,
    text: "A national lettings and estate agency network, the UK's leading provider of Guaranteed Rent.",
  },
  {
    name: "Martin & Co",
    logo: "/brands/martinco.png?v=3",
    dark: false,
    text: "A well-recognised residential lettings and sales brand with a broad presence across the United Kingdom.",
  },
];

const OurBrands = () => {
  return (
    <>
      <section className="bg-navy text-white pt-36 pb-24 lg:pt-44 lg:pb-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <Kicker light>Our Brands</Kicker>
            <Heading as="h1" className="text-4xl md:text-5xl lg:text-6xl max-w-4xl">
              The brands within the group.
            </Heading>
            <p className="mt-8 text-lg text-steel-light max-w-2xl leading-relaxed">
              OTP Group holds a small number of established property brands. Each continues to
              operate under its own name, supported by the group's stable, long-term ownership.
            </p>
          </Reveal>
        </div>
      </section>

      <Section stone>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {BRANDS.map((b, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                className="bg-white border border-navy/10 flex flex-col h-full overflow-hidden"
                data-testid={`brand-card-${i}`}
              >
                <div className="aspect-[16/9] bg-white border-b border-navy/10 flex items-center justify-center p-10">
                  <img
                    src={b.logo}
                    alt={`${b.name} logo`}
                    loading="lazy"
                    className="max-h-14 md:max-h-16 max-w-[75%] w-auto object-contain"
                  />
                </div>
                <div className="p-10">
                  <h3 className="text-xl font-semibold tracking-heading mb-3">{b.name}</h3>
                  <p className="text-steel leading-relaxed">{b.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
    </>
  );
};

export default OurBrands;
